import { FaFilePdf } from 'react-icons/fa'; // Import the FontAwesome PDF icon
import KceStaff from "./KceStaff"; // ✅ Import staff table
const FacultySection = () => {
  return (
    <section className="ftco-section ftco-no-pb">
<div className="container">
<div className="row justify-content-center pb-4">
    <div className="col-md-12  heading-section ftco-animate text px-4">
      <h2 className="mb-4 text-success text-center">
        <span className="text-warning">Our </span> Faculty
      </h2>   
    </div>
  </div>
    
  <div className="row ">
    <div className=" col-md-12 order-md-first">
      
             {/* Faculty Table from JSON */}
        
            <KceStaff /> {/* ✅ Staff table goes here */}
         
    </div>

  
        </div>  
       
  </div>

    </section>
  );
};

export default FacultySection;
